import { render, staticRenderFns } from "./ActiveFavorite.vue?vue&type=template&id=b3b46db2&lang=pug&"
import script from "./ActiveFavorite.vue?vue&type=script&lang=js&"
export * from "./ActiveFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports